import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Container, Section } from "src/components/common"
import { Title, List } from "./styles"

// Curated, ordered selection. `name` is the file name in src/assets/images/customers without extension.
const LOGOS = [
  { name: "C&A", label: "C&A" },
  { name: "Vodafone", label: "Vodafone" },
  { name: "toom", label: "toom Baumarkt" },
  { name: "Oral-B", label: "Oral-B" },
  { name: "Claudius Therme", label: "Claudius Therme Köln" },
  { name: "DOM", label: "DOM Sicherheitstechnik" },
  { name: "Hasenkopf", label: "Hasenkopf Industrie Manufaktur" },
  { name: "Geburtshaus", label: "Kölner Geburtshaus e.V." },
  {
    name: "MinisteriumBildung",
    label: "Ministerium für Schule und Bildung des Landes Nordrhein-Westfalen",
  },
  {
    name: "MinisteriumFamilie",
    label:
      "Ministerium für Kinder, Jugend, Familie, Gleichstellung, Flucht und Integration des Landes Nordrhein-Westfalen",
  },
  { name: "Miltenyi Biomedicine", label: "Miltenyi Biomedicine" },
  { name: "VfL Bochum", label: "VfL Bochum 1848" },
  { name: "SoSafe", label: "SoSafe" },
  { name: "Universitaet Duisburg-Essen", label: "Universität Duisburg-Essen" },
  { name: "iFun", label: "ifun.de" },
  { name: "objego-logo", label: "objego" },
]

export const Customers = () => {
  const { t } = useTranslation()
  const data = useStaticQuery(graphql`
    query {
      pngs: allFile(
        filter: {
          relativeDirectory: { eq: "customers" }
          extension: { eq: "png" }
        }
      ) {
        edges {
          node {
            name
            childImageSharp {
              resize(width: 300, height: 112, fit: INSIDE, quality: 85) {
                src
                width
                height
              }
            }
          }
        }
      }
      svgs: allFile(
        filter: {
          relativeDirectory: { eq: "customers" }
          extension: { eq: "svg" }
        }
      ) {
        edges {
          node {
            name
            publicURL
          }
        }
      }
    }
  `)
  const byName = [...data.pngs.edges, ...data.svgs.edges].reduce(
    (acc, { node }) => {
      acc[node.name.normalize("NFC")] = node
      return acc
    },
    {}
  )

  return (
    <Section aria-labelledby="customers-title" $compact $lined>
      <Container>
        <Title id="customers-title">{t("customers_headline")}</Title>
        <List>
          {LOGOS.map(({ name, label }) => {
            const node = byName[name.normalize("NFC")]
            if (!node) return null
            const resized = node.childImageSharp && node.childImageSharp.resize
            return (
              <li key={name}>
                {resized ? (
                  <img
                    src={resized.src}
                    width={resized.width}
                    height={resized.height}
                    alt={label}
                    loading="lazy"
                  />
                ) : (
                  <img
                    src={node.publicURL}
                    alt={label}
                    width="150"
                    height="56"
                    loading="lazy"
                  />
                )}
              </li>
            )
          })}
        </List>
      </Container>
    </Section>
  )
}
